export enum AreaSizeUnitEnum {
  HECTARES = "hectares",
  SQUARE_KILOMETRES = "squareKilometres",
  KILOMETERS_RADIUS = "kilometersRadius",
}
